import { NavSection } from './appTemplate.types';

export const hasVisibleNavItems = (sections: NavSection[]) =>
  sections.some((section) => section.items.some((item) => !item.hidden));
